"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.map");

require("core-js/modules/es.function.name");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _commonComponents = require("../commonComponents");

var _utils = require("./utils");

var _formElements = require("@evidation/form-elements");

var _deleteButton = _interopRequireDefault(require("./buttons/deleteButton"));

var _field = _interopRequireDefault(require("../field"));

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

//
// Render Flat Array
//
var FlatArray = function FlatArray(_ref) {
  var fields = _ref.fields,
      error = _ref.meta.error,
      type = _ref.type,
      required = _ref.required,
      movable = _ref.movable,
      nowDate = _ref.nowDate,
      addButtonLabel = _ref.addButtonLabel,
      moveUpButtonLabel = _ref.moveUpButtonLabel,
      moveDownButtonLabel = _ref.moveDownButtonLabel,
      components = _ref.components,
      deleteButtonIcon = _ref.deleteButtonIcon,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["fields", "meta", "type", "required", "movable", "nowDate", "addButtonLabel", "moveUpButtonLabel", "moveDownButtonLabel", "components", "deleteButtonIcon", "className"]);
  var _rest$config$disabled = rest.config.disabled,
      disabled = _rest$config$disabled === void 0 ? false : _rest$config$disabled;
  return /*#__PURE__*/_react["default"].createElement(_commonComponents.OuterUl, {
    className: "array flatArray"
  }, /*#__PURE__*/_react["default"].createElement(_commonComponents.Li, null, /*#__PURE__*/_react["default"].createElement(_commonComponents.InnerUl, null, rest.label && /*#__PURE__*/_react["default"].createElement(_formElements.InputLabel, {
    label: "".concat(rest.label),
    labelStyle: rest.labelStyle
  }), fields.map(function (fieldItem, index) {
    // if (!_.includes([`text`, `textinput`], type.toLowerCase())) {
    //   type = `textinput`;
    // }
    rest['id'] = "t-".concat(rest.config.name, "-").concat(index);
    return /*#__PURE__*/_react["default"].createElement(_commonComponents.InnerLi, {
      className: "row".concat(!_lodash["default"].isUndefined(className) ? " ".concat(className) : ""),
      key: fieldItem,
      id: "t-".concat(rest.config.name, "-").concat(index)
    }, /*#__PURE__*/_react["default"].createElement(_deleteButton["default"], {
      type: "button",
      className: "delete_row",
      id: "t-".concat(rest.config.name, "-").concat(index, "-delete"),
      onClick: function onClick() {
        return fields.remove(index);
      },
      deleteButtonIcon: deleteButtonIcon,
      disabled: disabled,
      render: function render() {
        return movable && !disabled && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_commonComponents.InnerButton, {
          className: "move_up",
          type: "button",
          id: "t-".concat(rest.config.name, "-").concat(index, "-moveup"),
          onClick: function onClick(e) {
            return (0, _utils.ArrayMoveUp)(e, index, fields);
          }
        }, moveUpButtonLabel), /*#__PURE__*/_react["default"].createElement(_commonComponents.InnerButton, {
          className: "move_down",
          type: "button",
          id: "t-".concat(rest.config.name, "-").concat(index, "-movedown"),
          onClick: function onClick(e) {
            return (0, _utils.ArrayMoveDown)(e, index, fields);
          }
        }, moveDownButtonLabel));
      }
    }), /*#__PURE__*/_react["default"].createElement(_commonComponents.InnerUl, null, /*#__PURE__*/_react["default"].createElement(_commonComponents.Li, null, /*#__PURE__*/_react["default"].createElement(_field["default"], (0, _extends2["default"])({}, rest, {
      "interface": type,
      components: components,
      key: fieldItem,
      name: fieldItem,
      required: required,
      label: "",
      nowDate: nowDate,
      disabled: disabled
    })))));
  })), error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error), /*#__PURE__*/_react["default"].createElement(_commonComponents.AddButton, {
    type: "button",
    className: "add_row",
    onClick: function onClick() {
      return fields.push();
    },
    buttonStyle: "confirm",
    id: "t-add_row_button-".concat(rest.config.name),
    disabled: disabled
  }, addButtonLabel)));
};

FlatArray.defaultProps = {
  className: undefined,
  type: "textinput",
  required: false,
  movable: false,
  addButtonLabel: "+ Add Row",
  moveUpButtonLabel: "\u25B2",
  moveDownButtonLabel: "\u25BC",
  deleteButtonIcon: "\u2716"
};
var _default = FlatArray;
exports["default"] = _default;